import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9.294 5H7V1.024L.024 8 7 14.976V11h2.294c2.579 0 5.748.268 8.285 5.118A8.647 8.647 0 0 0 9.294 5zm0 4.8H5.8v2.278L1.722 8 5.8 3.922V6.2h3.494c3.787 0 6.923 2.841 7.388 6.503C14.024 9.8 11.055 9.8 9.294 9.8z" />
  </svg>
);

export default SvgComponent;
